"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _store = require("@/api/store");
var _enum = require("../../enum");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var props = {
  children: 'child',
  label: 'name',
  value: 'id',
  emitPath: false
};
function _default(_ref) {
  var handleSearch = _ref.handleSearch;
  var FILTER_ITEMS = [{
    type: 'cascader',
    label: '商品分类：',
    prop: 'cateId',
    attrs: {
      placeholder: '请选择商品分类：',
      props: _objectSpread(_objectSpread({}, props), {}, {
        checkStrictly: true
      }),
      clearable: true,
      size: 'small',
      options: []
    },
    events: {
      change: function change(value) {
        return handleSearch({
          cateId: value
        });
      }
    }
  },
  // {
  //     type: 'cascader',
  //     label: '展示分类：',
  //     prop: 'showCateId',
  //     attrs: {
  //         placeholder: '请选择展示分类',
  //         props: {...props, multiple: true, checkStrictly: true },
  //         clearable: true,
  //         size: 'small',
  //         options: [],
  //     },
  //     events: { change: (value) => handleSearch({ showCateId: value }) },
  // },
  {
    type: 'cascader',
    label: '产地：',
    prop: 'areaId',
    attrs: {
      placeholder: '请选择产地',
      props: _objectSpread(_objectSpread({}, props), {}, {
        checkStrictly: true
      }),
      clearable: true,
      size: 'small',
      options: []
    },
    events: {
      change: function change(value) {
        return handleSearch({
          areaId: value
        });
      }
    }
  },
  // {
  //     type: 'select', // 输入框
  //     label: '供应商：',
  //     prop: 'supplierId',
  //     attrs: {
  //         placeholder: '请选择供应商',
  //         props,
  //         size: 'small',
  //         filterable: true,
  //         remote: true,
  //         clearable: true,
  //         'remote-method': getSupplierList,
  //     },
  //     options: [],
  //     events: { change: (value) => handleSearch({ supplierId: value }) },
  // },
  {
    type: 'select',
    label: '商品品牌：',
    prop: 'brandId',
    attrs: {
      placeholder: '请选择商品品牌',
      props: props,
      size: 'small',
      filterable: true,
      remote: true,
      clearable: true,
      'remote-method': getBrandList
    },
    options: [],
    events: {
      change: function change(value) {
        return handleSearch({
          brandId: value
        });
      }
    }
  }, {
    type: 'select',
    label: '商品标签：',
    prop: 'labelId',
    attrs: {
      placeholder: '请选择商品标签',
      props: props,
      size: 'small',
      filterable: true,
      remote: true,
      clearable: true,
      'remote-method': getLabelList
    },
    options: [],
    events: {
      change: function change(value) {
        return handleSearch({
          labelId: value
        });
      }
    }
  }, {
    type: 'input',
    label: 'SPU名称：',
    prop: 'spuName',
    attrs: {
      placeholder: '请输入SPU名称',
      clearable: true,
      size: 'small'
    },
    events: {
      change: function change(value) {
        return handleSearch({
          spuName: value
        });
      }
    }
  }, {
    type: 'input',
    label: 'SPU编码：',
    prop: 'spuCode',
    attrs: {
      placeholder: '请输入SPU编码',
      clearable: true,
      size: 'small'
    },
    events: {
      change: function change(value) {
        return handleSearch({
          spuCode: value
        });
      }
    }
  }, {
    type: 'select',
    label: '排序方式：',
    prop: 'orderByType',
    attrs: {
      placeholder: '请选择排序方式',
      props: props,
      size: 'small',
      clearable: true
    },
    options: _enum.orderByTypeEnum,
    events: {
      change: function change(value) {
        return handleSearch({
          orderByType: value
        });
      }
    }
  }, {
    type: 'pickerRange',
    label: '创建时间：',
    prop: 'dateRange',
    attrs: {
      placeholder: '请选择创建时间',
      clearable: true
    },
    events: {
      change: function change(value) {
        return handleSearch({
          dateRange: value
        });
      }
    }
  }, {
    type: 'select',
    label: '审核状态：',
    prop: 'auditStatus',
    attrs: {
      placeholder: '请选择审核状态',
      props: props,
      size: 'small',
      clearable: true
    },
    options: _enum.auditStatusEnum,
    events: {
      change: function change(value) {
        return handleSearch({
          isVerify: value
        });
      }
    }
  }];

  // 分类
  function getCategorySelect(_x) {
    return _getCategorySelect.apply(this, arguments);
  } // 产地
  function _getCategorySelect() {
    _getCategorySelect = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(type) {
      var res, _t, _t2;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            _context.n = 1;
            return (0, _store.categoryApi)({
              status: -1,
              type: type
            });
          case 1:
            res = _context.v;
            _t = type;
            _context.n = _t === 1 ? 2 : _t === 8 ? 3 : 4;
            break;
          case 2:
            FILTER_ITEMS[0].attrs.options = res || [];
            return _context.a(3, 5);
          case 3:
            FILTER_ITEMS[1].attrs.options = res || [];
            return _context.a(3, 5);
          case 4:
            return _context.a(3, 5);
          case 5:
            _context.n = 7;
            break;
          case 6:
            _context.p = 6;
            _t2 = _context.v;
            console.error(_t2);
          case 7:
            return _context.a(2);
        }
      }, _callee, null, [[0, 6]]);
    }));
    return _getCategorySelect.apply(this, arguments);
  }
  function getPlaceList() {
    return _getPlaceList.apply(this, arguments);
  } //供应商
  function _getPlaceList() {
    _getPlaceList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var res, _t3;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            _context2.p = 0;
            _context2.n = 1;
            return (0, _store.getCityApi)();
          case 1:
            res = _context2.v;
            FILTER_ITEMS[2].attrs.options = res || [];
            _context2.n = 3;
            break;
          case 2:
            _context2.p = 2;
            _t3 = _context2.v;
            console.error(_t3);
          case 3:
            return _context2.a(2);
        }
      }, _callee2, null, [[0, 2]]);
    }));
    return _getPlaceList.apply(this, arguments);
  }
  function getSupplierList() {
    return _getSupplierList.apply(this, arguments);
  } // 品牌
  function _getSupplierList() {
    _getSupplierList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var query,
        params,
        res,
        _args3 = arguments,
        _t4;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            query = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : '';
            params = {
              keyword: query
            };
            _context3.p = 1;
            _context3.n = 2;
            return (0, _store.getSupplierApi)(params);
          case 2:
            res = _context3.v;
            FILTER_ITEMS[3].options = res.map(function (item) {
              return {
                label: item.supplierName,
                value: item.id
              };
            }) || [];
            _context3.n = 4;
            break;
          case 3:
            _context3.p = 3;
            _t4 = _context3.v;
            console.error(_t4);
          case 4:
            return _context3.a(2);
        }
      }, _callee3, null, [[1, 3]]);
    }));
    return _getSupplierList.apply(this, arguments);
  }
  function getBrandList() {
    return _getBrandList.apply(this, arguments);
  } // 标签
  function _getBrandList() {
    _getBrandList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      var query,
        params,
        res,
        _args4 = arguments,
        _t5;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            query = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : '';
            params = {
              keyword: query
            };
            _context4.p = 1;
            _context4.n = 2;
            return (0, _store.getBrandrApi)(params);
          case 2:
            res = _context4.v;
            FILTER_ITEMS[4].options = res.map(function (item) {
              return {
                label: item.brandName,
                value: item.id
              };
            }) || [];
            _context4.n = 4;
            break;
          case 3:
            _context4.p = 3;
            _t5 = _context4.v;
            console.error(error);
          case 4:
            return _context4.a(2);
        }
      }, _callee4, null, [[1, 3]]);
    }));
    return _getBrandList.apply(this, arguments);
  }
  function getLabelList() {
    return _getLabelList.apply(this, arguments);
  } // 获取基本数据
  function _getLabelList() {
    _getLabelList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
      var query,
        params,
        res,
        _args5 = arguments,
        _t6;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            query = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : '';
            params = {
              keyword: query
            };
            _context5.p = 1;
            _context5.n = 2;
            return (0, _store.getLabelApi)(params);
          case 2:
            res = _context5.v;
            FILTER_ITEMS[5].options = res.map(function (item) {
              return {
                label: item.labelName,
                value: item.id
              };
            }) || [];
            _context5.n = 4;
            break;
          case 3:
            _context5.p = 3;
            _t6 = _context5.v;
            console.error(error);
          case 4:
            return _context5.a(2);
        }
      }, _callee5, null, [[1, 3]]);
    }));
    return _getLabelList.apply(this, arguments);
  }
  getCategorySelect(1);
  getCategorySelect(8);
  getPlaceList();
  getSupplierList();
  getBrandList();
  getLabelList();
  return {
    FILTER_ITEMS: FILTER_ITEMS
  };
}